const data = [
"ic_ai_icon_add_new",
"ic_ai_icon_api",
"ic_ai_icon_ar_1",
"ic_ai_icon_ar_2",
"ic_ai_icon_ar_3",
"ic_ai_icon_arrow_1",
"ic_ai_icon_arrow_upside",
"ic_ai_icon_back_1",
"ic_ai_icon_back_2",
"ic_ai_icon_back_3",
"ic_ai_icon_back_4",
"ic_ai_icon_back_5",
"ic_ai_icon_block",
"ic_ai_icon_bold",
"ic_ai_icon_bookmark_1",
"ic_ai_icon_bookmark_10",
"ic_ai_icon_bookmark_11",
"ic_ai_icon_bookmark_12",
"ic_ai_icon_bookmark_13",
"ic_ai_icon_bookmark_14",
"ic_ai_icon_bookmark_15",
"ic_ai_icon_bookmark_16",
"ic_ai_icon_bookmark_17",
"ic_ai_icon_bookmark_2",
"ic_ai_icon_bookmark_3",
"ic_ai_icon_bookmark_4",
"ic_ai_icon_bookmark_5",
"ic_ai_icon_bookmark_6",
"ic_ai_icon_bookmark_7",
"ic_ai_icon_bookmark_8",
"ic_ai_icon_bookmark_9",
"ic_ai_icon_broadcast_message",
"ic_ai_icon_business",
"ic_ai_icon_calendar_1",
"ic_ai_icon_call_1",
"ic_ai_icon_call_10",
"ic_ai_icon_call_11",
"ic_ai_icon_call_12",
"ic_ai_icon_call_13",
"ic_ai_icon_call_14",
"ic_ai_icon_call_15",
"ic_ai_icon_call_16",
"ic_ai_icon_call_17",
"ic_ai_icon_call_18",
"ic_ai_icon_call_19",
"ic_ai_icon_call_2",
"ic_ai_icon_call_20",
"ic_ai_icon_call_21",
"ic_ai_icon_call_22",
"ic_ai_icon_call_23",
"ic_ai_icon_call_24",
"ic_ai_icon_call_25",
"ic_ai_icon_call_26",
"ic_ai_icon_call_27",
"ic_ai_icon_call_28",
"ic_ai_icon_call_29",
"ic_ai_icon_call_3",
"ic_ai_icon_call_30",
"ic_ai_icon_call_31",
"ic_ai_icon_call_4",
"ic_ai_icon_call_5",
"ic_ai_icon_call_6",
"ic_ai_icon_call_7",
"ic_ai_icon_call_8",
"ic_ai_icon_call_9",
"ic_ai_icon_cart_1",
"ic_ai_icon_cart_10",
"ic_ai_icon_cart_11",
"ic_ai_icon_cart_12",
"ic_ai_icon_cart_13",
"ic_ai_icon_cart_14",
"ic_ai_icon_cart_15",
"ic_ai_icon_cart_16",
"ic_ai_icon_cart_17",
"ic_ai_icon_cart_18",
"ic_ai_icon_cart_19",
"ic_ai_icon_cart_2",
"ic_ai_icon_cart_20",
"ic_ai_icon_cart_21",
"ic_ai_icon_cart_22",
"ic_ai_icon_cart_23",
"ic_ai_icon_cart_24",
"ic_ai_icon_cart_25",
"ic_ai_icon_cart_26",
"ic_ai_icon_cart_3",
"ic_ai_icon_cart_4",
"ic_ai_icon_cart_5",
"ic_ai_icon_cart_6",
"ic_ai_icon_cart_7",
"ic_ai_icon_cart_8",
"ic_ai_icon_cart_9",
"ic_ai_icon_chat_1",
"ic_ai_icon_chat_2",
"ic_ai_icon_chat_3",
"ic_ai_icon_chat_4",
"ic_ai_icon_chat_bottom_bar",
"ic_ai_icon_chat_view",
"ic_ai_icon_close_1",
"ic_ai_icon_close_2",
"ic_ai_icon_close_3",
"ic_ai_icon_close_4",
"ic_ai_icon_close_5",
"ic_ai_icon_close_6",
"ic_ai_icon_close_7",
"ic_ai_icon_conversation",
"ic_ai_icon_correct_answer_sign",
"ic_ai_icon_correct_answer_tick",
"ic_ai_icon_delete_1",
"ic_ai_icon_delete_10",
"ic_ai_icon_delete_11",
"ic_ai_icon_delete_2",
"ic_ai_icon_delete_3",
"ic_ai_icon_delete_4",
"ic_ai_icon_delete_5",
"ic_ai_icon_delete_6",
"ic_ai_icon_delete_7",
"ic_ai_icon_delete_8",
"ic_ai_icon_delete_9",
"ic_ai_icon_done",
"ic_ai_icon_done_1",
"ic_ai_icon_done_10",
"ic_ai_icon_done_11",
"ic_ai_icon_done_12",
"ic_ai_icon_done_13",
"ic_ai_icon_done_14",
"ic_ai_icon_done_15",
"ic_ai_icon_done_16",
"ic_ai_icon_done_17",
"ic_ai_icon_done_18",
"ic_ai_icon_done_2",
"ic_ai_icon_done_3",
"ic_ai_icon_done_4",
"ic_ai_icon_done_5",
"ic_ai_icon_done_6",
"ic_ai_icon_done_7",
"ic_ai_icon_done_8",
"ic_ai_icon_done_9",
"ic_ai_icon_double_down_1",
"ic_ai_icon_double_down_2",
"ic_ai_icon_download_1",
"ic_ai_icon_download_2",
"ic_ai_icon_download_3",
"ic_ai_icon_download_4",
"ic_ai_icon_download_5",
"ic_ai_icon_draggable_icon",
"ic_ai_icon_edit_1",
"ic_ai_icon_edit_10",
"ic_ai_icon_edit_11",
"ic_ai_icon_edit_12",
"ic_ai_icon_edit_13",
"ic_ai_icon_edit_14",
"ic_ai_icon_edit_15",
"ic_ai_icon_edit_16",
"ic_ai_icon_edit_2",
"ic_ai_icon_edit_3",
"ic_ai_icon_edit_4",
"ic_ai_icon_edit_5",
"ic_ai_icon_edit_6",
"ic_ai_icon_edit_7",
"ic_ai_icon_edit_8",
"ic_ai_icon_edit_9",
"ic_ai_icon_email_1",
"ic_ai_icon_empty_heart_1",
"ic_ai_icon_empty_heart_2",
"ic_ai_icon_empty_heart_3",
"ic_ai_icon_empty_heart_4",
"ic_ai_icon_empty_heart_5",
"ic_ai_icon_empty_heart_6",
"ic_ai_icon_empty_heart_7",
"ic_ai_icon_empty_heart_8",
"ic_ai_icon_fill_heart_1",
"ic_ai_icon_fill_heart_2",
"ic_ai_icon_fill_heart_3",
"ic_ai_icon_fill_heart_4",
"ic_ai_icon_fill_heart_5",
"ic_ai_icon_fill_heart_6",
"ic_ai_icon_fill_heart_7",
"ic_ai_icon_fill_heart_8",
"ic_ai_icon_filter_1",
"ic_ai_icon_filter_2",
"ic_ai_icon_filter_3",
"ic_ai_icon_filter_4",
"ic_ai_icon_filter_5",
"ic_ai_icon_filter_6",
"ic_ai_icon_game_setting_1",
"ic_ai_icon_game_setting_10",
"ic_ai_icon_game_setting_11",
"ic_ai_icon_game_setting_12",
"ic_ai_icon_game_setting_13",
"ic_ai_icon_game_setting_14",
"ic_ai_icon_game_setting_21",
"ic_ai_icon_game_setting_3",
"ic_ai_icon_game_setting_4",
"ic_ai_icon_game_setting_5",
"ic_ai_icon_game_setting_6",
"ic_ai_icon_game_setting_7",
"ic_ai_icon_game_setting_8",
"ic_ai_icon_game_setting_9",
"ic_ai_icon_hand_shake",
"ic_ai_icon_heart_1",
"ic_ai_icon_heart_2",
"ic_ai_icon_heart_3",
"ic_ai_icon_heart_4",
"ic_ai_icon_heart_5",
"ic_ai_icon_heart_6",
"ic_ai_icon_heart_7",
"ic_ai_icon_heart_8",
"ic_ai_icon_home_1",
"ic_ai_icon_info_1",
"ic_ai_icon_info_2",
"ic_ai_icon_info_3",
"ic_ai_icon_info_4",
"ic_ai_icon_invite_1",
"ic_ai_icon_invite_2",
"ic_ai_icon_invite_3",
"ic_ai_icon_invite_4",
"ic_ai_icon_invite_5",
"ic_ai_icon_invite_6",
"ic_ai_icon_italic",
"ic_ai_icon_jobs_1",
"ic_ai_icon_link_1",
"ic_ai_icon_link_2",
"ic_ai_icon_link_3",
"ic_ai_icon_location_1",
"ic_ai_icon_location_10",
"ic_ai_icon_location_11",
"ic_ai_icon_location_12",
"ic_ai_icon_location_13",
"ic_ai_icon_location_14",
"ic_ai_icon_location_15",
"ic_ai_icon_location_16",
"ic_ai_icon_location_17",
"ic_ai_icon_location_18",
"ic_ai_icon_location_19",
"ic_ai_icon_location_2",
"ic_ai_icon_location_20",
"ic_ai_icon_location_21",
"ic_ai_icon_location_22",
"ic_ai_icon_location_23",
"ic_ai_icon_location_24",
"ic_ai_icon_location_25",
"ic_ai_icon_location_26",
"ic_ai_icon_location_27",
"ic_ai_icon_location_28",
"ic_ai_icon_location_29",
"ic_ai_icon_location_3",
"ic_ai_icon_location_30",
"ic_ai_icon_location_31",
"ic_ai_icon_location_32",
"ic_ai_icon_location_33",
"ic_ai_icon_location_4",
"ic_ai_icon_location_5",
"ic_ai_icon_location_6",
"ic_ai_icon_location_7",
"ic_ai_icon_location_8",
"ic_ai_icon_location_9",
"ic_ai_icon_lock",
"ic_ai_icon_lock_view",
"ic_ai_icon_mail",
"ic_ai_icon_menu_1",
"ic_ai_icon_menu_2",
"ic_ai_icon_menu_3",
"ic_ai_icon_menu_4",
"ic_ai_icon_menu_5",
"ic_ai_icon_menu_6",
"ic_ai_icon_notification_gear_1",
"ic_ai_icon_notification_gear_10",
"ic_ai_icon_notification_gear_2",
"ic_ai_icon_notification_gear_3",
"ic_ai_icon_notification_gear_4",
"ic_ai_icon_notification_gear_5",
"ic_ai_icon_notification_gear_6",
"ic_ai_icon_notification_gear_7",
"ic_ai_icon_notification_gear_8",
"ic_ai_icon_notification_gear_9",
"ic_ai_icon_pause",
"ic_ai_icon_pdf",
"ic_ai_icon_people_1",
"ic_ai_icon_phone",
"ic_ai_icon_play_arrow",
"ic_ai_icon_player_settings",
"ic_ai_icon_poll",
"ic_ai_icon_poll_bottom_bar",
"ic_ai_icon_profile_1",
"ic_ai_icon_profile_10",
"ic_ai_icon_profile_2",
"ic_ai_icon_profile_3",
"ic_ai_icon_profile_4",
"ic_ai_icon_profile_5",
"ic_ai_icon_profile_6",
"ic_ai_icon_profile_7",
"ic_ai_icon_profile_8",
"ic_ai_icon_profile_9",
"ic_ai_icon_qa_bottom_bar",
"ic_ai_icon_question",
"ic_ai_icon_refresh_1",
"ic_ai_icon_refresh_10",
"ic_ai_icon_refresh_11",
"ic_ai_icon_refresh_12",
"ic_ai_icon_refresh_2",
"ic_ai_icon_refresh_3",
"ic_ai_icon_refresh_4",
"ic_ai_icon_refresh_5",
"ic_ai_icon_refresh_6",
"ic_ai_icon_refresh_7",
"ic_ai_icon_refresh_8",
"ic_ai_icon_refresh_9",
"ic_ai_icon_relocate",
"ic_ai_icon_remote_1",
"ic_ai_icon_save_1",
"ic_ai_icon_save_2",
"ic_ai_icon_save_3",
"ic_ai_icon_save_4",
"ic_ai_icon_scale",
"ic_ai_icon_schedule_1",
"ic_ai_icon_schedule_10",
"ic_ai_icon_schedule_11",
"ic_ai_icon_schedule_12",
"ic_ai_icon_schedule_13",
"ic_ai_icon_schedule_14",
"ic_ai_icon_schedule_15",
"ic_ai_icon_schedule_16",
"ic_ai_icon_schedule_17",
"ic_ai_icon_schedule_18",
"ic_ai_icon_schedule_19",
"ic_ai_icon_schedule_2",
"ic_ai_icon_schedule_20",
"ic_ai_icon_schedule_21",
"ic_ai_icon_schedule_22",
"ic_ai_icon_schedule_3",
"ic_ai_icon_schedule_4",
"ic_ai_icon_schedule_5",
"ic_ai_icon_schedule_6",
"ic_ai_icon_schedule_7",
"ic_ai_icon_schedule_8",
"ic_ai_icon_schedule_9",
"ic_ai_icon_search_1",
"ic_ai_icon_search_2",
"ic_ai_icon_search_3",
"ic_ai_icon_search_4",
"ic_ai_icon_search_5",
"ic_ai_icon_search_6",
"ic_ai_icon_search_7",
"ic_ai_icon_search_8",
"ic_ai_icon_search_9",
"ic_ai_icon_send_1",
"ic_ai_icon_send_10",
"ic_ai_icon_send_11",
"ic_ai_icon_send_12",
"ic_ai_icon_send_13",
"ic_ai_icon_send_2",
"ic_ai_icon_send_3",
"ic_ai_icon_send_4",
"ic_ai_icon_send_5",
"ic_ai_icon_send_6",
"ic_ai_icon_send_7",
"ic_ai_icon_send_8",
"ic_ai_icon_send_9",
"ic_ai_icon_setting_22",
"ic_ai_icon_share_1",
"ic_ai_icon_share_10",
"ic_ai_icon_share_11",
"ic_ai_icon_share_12",
"ic_ai_icon_share_13",
"ic_ai_icon_share_14",
"ic_ai_icon_share_2",
"ic_ai_icon_share_3",
"ic_ai_icon_share_4",
"ic_ai_icon_share_5",
"ic_ai_icon_share_6",
"ic_ai_icon_share_7",
"ic_ai_icon_share_8",
"ic_ai_icon_share_9",
"ic_ai_icon_skills",
"ic_ai_icon_skip_1",
"ic_ai_icon_skip_2",
"ic_ai_icon_skip_3",
"ic_ai_icon_star",
"ic_ai_icon_strikethrough",
"ic_ai_icon_threedot_1",
"ic_ai_icon_threedot_2",
"ic_ai_icon_threedot_3",
"ic_ai_icon_thumb_icon",
"ic_ai_icon_tick",
"ic_ai_icon_time_1",
"ic_ai_icon_valume_off",
"ic_ai_icon_valume_up",
"ic_ai_icon_video_call_1",
"ic_ai_icon_video_call_10",
"ic_ai_icon_video_call_11",
"ic_ai_icon_video_call_12",
"ic_ai_icon_video_call_13",
"ic_ai_icon_video_call_14",
"ic_ai_icon_video_call_2",
"ic_ai_icon_video_call_3",
"ic_ai_icon_video_call_4",
"ic_ai_icon_video_call_5",
"ic_ai_icon_video_call_6",
"ic_ai_icon_video_call_7",
"ic_ai_icon_video_call_8",
"ic_ai_icon_video_call_9",
"ic_ai_icon_warning",
"ic_ai_icon_zoom_out",
        
"icon-spotify-alt",
"icon-town-hall",
"icon-info-circled",
"icon-theatre",
"icon-laptop",
"icon-stethoscope",
"icon-restaurant",
"icon-umbrella",
"icon-puzzle",
"icon-harbor",
"icon-share-1",
"icon-edit-2",
"icon-fire-station",
"iconz-briefcase",
"iconz-education",
"iconz-picture",
"iconz-fashion",
"iconz-law",
"iconz-band",
"iconz-celebrity",
"iconz-catering",
"iconz-hirecab",
"iconz-casino",
"iconz-account",
"iconz-contractor",
"iconz-worship",
"iconz-login",
"iconz-news",
"iconz-ebook",
"iconz-directory",
"iconz-gift",
"iconz-user",
"iconz-video",
"iconz-audio",
"iconz-globe",
"icon-vk",
"icon-check-1",
"icon-credit-card-2",
"icon-fast-food",
"icon-facebook-circled",
"icon-gplus-circled",
"icon-googleplus-rect",
"icon-college",
"icon-blogger-rect",
"icon-list-2",
"icon-calendar-4",
"icon-twitter-circled",
"icon-rss-alt-1",
"icon-linkedin-rect",
"icon-code",
"icon-cart",
"icon-religious-christian",
"icon-quote",
"icon-chat-empty",
"icon-doc-alt",
"icon-menu",
"icon-tools",
"icon-phone-squared",
"icon-map",
"icon-vcard",
"icon-qrcode",
"icon-cog-alt",
"icon-dot-3",
"icon-indent-right",
"icon-indent-nowrap",
"icon-book-1",
"icon-wordpress-1",
"icon-blogger",
"icon-eventful",
"icon-eventbrite",
"icon-facebook",
"icon-religious-islam",
"icon-clock-4",
"iconz-target",
"icon-cancel-circle-1",
"icon-shop",
"icon-coffee",
"icon-garden",
"iconz-megaphone",
"icon-emo-happy",
"icon-star-1",
"icon-ok-4",
"iconz-glass",
"icon-cog",
"icon-underline",
"icon-vimeo-rect",
"icon-play-circle2-1",
"iconz-video-hd",
"icon-camera-1",
"icon-location-2",
"icon-barcode",
"icon-cloud-sun-inv",
"icon-sunrise",
"icon-picasa-1",
"icon-flickr",
"icon-pinterest-1",
"iconz-camera",
"icon-soundcloud-1",
"icon-rss",
"icon-signal-3",
"icon-rss-alt",
"icon-indent-left",
"icon-location",
"icon-email",
"icon-skype-1",
"icon-globe-3",
"icon-calendar-inv",
"icon-right-open-1",
"icon-down-open-1",
"icon-compass",
"icon-award-2",
"icon-facebook-rect-1",
"icon-twitter-bird-1",
"icon-youtube",
"icon-instagram-filled",
"icon-pinterest-circled-1",
"icon-cancel",
"icon-left-open",
"icon-target-1",
"icon-angle-double-right",
"icon-android",
"icon-appstore",
"icon-windows",
"icon-amazon",
"icon-th-large-1",
"icon-edit",
"icon-list-add",
"icon-down-open",
"icon-right-open",
"icon-cog-4",
"icon-cancel-circled",
"icon-eye-off",
"icon-eye",
"icon-eye-1",
"icon-trash",
"icon-plus-3",
"icon-angle-double-left",
"iconz-upload",
"iconz-calculator",
"iconz-mcalculator",
"iconz-peedometer",
"iconz-beer",
"iconz-drink",
"iconz-icecream",
"iconz-crown",
"iconz-close",
"icon-font",
"icon-picture-3",
"icon-block-4",
"icon-blank",
"icon-align-left",
"icon-align-center",
"icon-align-right",
"icon-trash-1",
"icon-heart-1",
"icon-table",
"icon-left-1",
"icon-info-circle",
"icon-plus-circle-1",
"icon-left-open-2",
"icon-instagram",
"icon-mobile-2",
"iconz-mobile",
"iconz-phone1",
"iconz-phone",
"icon-menu-1",
"icon-search-3",
"iconz-quiz",
"iconz-ticket",
"iconz-socialnetwork",
"icon-facebook-1",
"iconz-location-3",
"icon-spin3",
"iconz-lock",
"iconz-unlock",
"iconz-thumbs-up",
"iconz-thumbs-down",
"iconz-realestate",
"iconz-sports",
"iconz-fitness",
"iconz-travel",
"iconz-veterinary",
"iconz-asterisk",
"iconz-home",
"iconz-user-asterisk",
"iconz-logout",
"iconz-log-in",
"iconz-star-empty",
"iconz-star",
"iconz-music",
"icon-yelp",
"iconz-chat",
"iconz-location-chat",
"icon-comment",
"icon-tumblr",
"icon-color-book",
"icon-chart",
"icon-html5",
"icon-warn",
"iconz-hosting",
"iconz-signal",
"icon-circle",
"icon-circle-empty",
"icon-play-1",
"iconz-download",
"icon-bell-alt",
"icon-link-1",
"icon-print-3",
"icon-print-2",
"icon-brush-1",
"iconz-plug",
"iconz-signal3",
"icon-book-2",
"icon-download",
"icon-drupal",
"icon-calendar-1",
"icon-clock-alt",
"icon-dollar",
"icon-clock",
"iconz-bed",
"iconz-play-button",
"icon-paypal-1",
"icon-floppy",
"icon-floppy-1",
"iconz-user-ban",
"iconz-user-add",
"icon-users-1",
"icon-users-2",
"icon-angle-left",
"icon-angle-right",
"icon-mobile-2",
"icon-mobile-3",
"icon-mobile-4",
"icon-tags",
"icon-layers",
"iconz-downloads",
"iconz-currency-conversion",
"iconz-import",
"iconz-export",
"iconz-transfer",
"iconz-calendar",
"iconz-newspaper",
"iconz-message-ban",
"icon-listing",
"iconz-dirList",
"iconz-wifi",
"iconz-snowflake",
"iconz-bath-bathtub",
"iconz-tv",
"iconz-phone-alt",
"iconz-checkbox",
"iconz-uncheckbox",
"iconz-pool",
"iconz-scuba-diving",
"iconz-person-running",
"iconz-car",
"iconz-family",
"iconz-eye-plus",
"iconz-eye-minus",
"icon-minus-3",
"icon-logout",
"icon-home",
"icon-home-1",
"icon-home-2",
"icon-home-3",
"icon-home-4",
"iconz-bookmark",
"icon-bookmark-empty",
"icon-sun-2",
"icon-chat-3",
"iconz-text-size",
"iconz-filter",
"icon-music-1",
"iconz-message-ban",
"iconz-message-flag",
"iconz-group-chat",
"iconz-promotion",
"iconz-alarm",
"iconz-multiple-displays",
"iconz-coat-hanger",
"iconz-one-day",
"iconz-open-water",
"iconz-list-plus",
"iconz-temple-islam",
"iconz-crop",
"iconz-global",
"iconz-thumbs-up",
"iconz-thumbs-down",
"icon-twitter-rect",
"icon-left-dir-1",
"icon-right-dir-1",
"icon-down-dir-1",
"icon-up-dir-1",
"iconz-pencil",
"icon-comment",
"icon-comment-2",
"icon-quote-left-1",
"icon-quote",
"icon-quote-right-1",
"icon-gmail",
"icon-yahoo",
"icon-up-hand",
"icon-resize-full-4",
"iconz-database",
"iconz-iphone",
"iconz-ipad",
"icon-star",
"icon-star-empty-1",
"icon-star-1",
"icon-linkedin-1",
"icon-thumbs-up-1",
"icon-thumbs-down-1",
"icon-reply-1",
"icon-right-1",
"icon-google",
"icon-googleplus-rect-1",
"icon-user-add",
"iconz-option-vertical",
"iconz-option-horizontal",
"icon-info",
"iconz-ban-circle",
"iconz-remove",
"icon-flag",
"icon-bold",
"icon-italic",
"icon-underline",
"icon-strike",
"icon-link",
"icon-emo-nodata",
"icon-star-half",
"iconz-click-call",
"icon-book-2",
"icon-bookmark-2",
"iconz-bullhorn",
"iconz-pause",
"iconz-buildings",
"icon-chart-1",
"icon-doc-invz",
"icon-doc-altz-1",
"icon-doc-inv-altz",
"icon-docz-4",
"icon-picturez-2",
"icon-doc-text-invz",
"icon-chart-1",
"iconz-view-360",
"icon-emo-unhappy",
"icon-emo-wink2",
"icon-emo-cry",
"icon-emo-sunglasses",
"iconz-life-preserver",
"icon-shareable",
"iconz-sorting",
"iconz-door",
"iconz-comments",
"iconz-share-alt",
"icon-truck",
"iconz-bedroom-nightstand",
"iconz-scissors",
"icon-heart-empty-1",
"iconz-hourglass",
"iconz-send",
"iconz-thumbnails",
"iconz-list",
"iconz-fire",
"icon-angle-double-down",
"appyicon-veg-nonveg",
"icon-right-hand",
"icon-docs-1",
"icon-left-hand",
"appyicon-add-bookmark",
"appyicon-add-bookmark-empty",
"appyicon-americommerce",
"appyicon-appointel",
"appyicon-appointy",
"appyicon-aquityscheduling",
"appyicon-ar",
"appyicon-bandsintown",
"appyicon-bigcommerce",
"appyicon-blackberry",
"appyicon-blocked-cart",
"appyicon-booker",
"appyicon-bookmyshow",
"appyicon-ebay2",
"appyicon-e-marketing",
"appyicon-drag-drop",
"appyicon-dotnetnuke",
"appyicon-doc",
"appyicon-disableglobe",
"appyicon-delivery",
"appyicon-dailymotion",
"appyicon-cricket",
"appyicon-concrete5",
"appyicon-cms",
"appyicon-chat-bubble",
"appyicon-c2call",
"appyicon-edit-image",
"appyicon-indian-rupee",
"appyicon-img",
"appyicon-hyperlocal-icon",
"appyicon-goicon",
"appyicon-gita",
"appyicon-genbook",
"appyicon-gaana",
"appyicon-foursqaure",
"appyicon-foldericon",
"appyicon-flag",
"appyicon-etsy",
"appyicon-empty-cart",
"appyicon-joomla",
"appyicon-khanacadmy",
"appyicon-like",
"appyicon-line-chat",
"appyicon-lounge-icon",
"appyicon-loyalty",
"appyicon-magento",
"appyicon-mail",
"appyicon-messenger",
"appyicon-mindobody",
"appyicon-modex",
"appyicon-mouthshut",
"appyicon-news-text-size",
"appyicon-pdfs",
"appyicon-pdf",
"appyicon-payu-money",
"appyicon-pause",
"appyicon-panorama",
"appyicon-oscommerce",
"appyicon-opentable",
"appyicon-ooyala",
"appyicon-onetouch",
"appyicon-no-network",
"appyicon-no-data",
"appyicon-no-bookmark",
"appyicon-news-upload",
"appyicon-pokemon1600",
"appyicon-ppt",
"appyicon-practo",
"appyicon-prestashop",
"appyicon-pricetag",
"appyicon-raaga",
"appyicon-ru-currency",
"appyicon-saavn",
"appyicon-salesforce",
"appyicon-schedulicity",
"appyicon-scheduling",
"appyicon-send",
"appyicon-shopify",
"appyicon-typo3",
"appyicon-txt",
"appyicon-tour-desk",
"appyicon-tinycms",
"appyicon-time-out",
"appyicon-textpettern",
"appyicon-symbian",
"appyicon-stripe",
"appyicon-squarespace",
"appyicon-spa-icon",
"appyicon-social-share",
"appyicon-social-comments",
"appyicon-snap-chat",
"appyicon-veg-nonveg",
"appyicon-volusion",
"appyicon-wallet",
"appyicon-we-chat",
"appyicon-wedding",
"appyicon-whatsapp",
"appyicon-woocommerce",
"appyicon-xls",
"appyicon-zip",
"appyicon-zoho",
"appyicon-zomato",
"appyicon-zopim",
"appyicon-check-symbol",
"appyicon-double-check-symbol",
"appyicon-paid",
"appyicon-unpaid",
"appyicon-user-verified",
"appyicon-chat-bots",
"appyicon-google-photos",
"appyicon-facebook-live",
"appyicon-audio-fast-backward",
"appyicon-audio-fast-forward",
"appyicon-audio-mute",
"appyicon-audio-next",
"appyicon-audio-previous",
"appyicon-audio-repeat",
"appyicon-audio-unmute",
"appyicon-pencil-edit-button",
"appyicon-sort-down",
"appyicon-save-content",
"appyicon-dinein",
"appyicon-grubhub",
"appyicon-pizza",
"appyicon-pf-icon",
"appyicon-home",
"appyicon-favorites",
"appyicon-document",
"appyicon-free-apps",
"appyicon-list",
"appyicon-paid-apps",
"appyicon-pwa",
"appyicon-meetup",
"appyicon-coupon-directory",
"appyicon-pluscode",
"icon-angle-double-up",
"icon-play",
"icon-stop",
"appyicon-essential",
"iconz-message-in",
"appyicon-hear-this",
"icon-ok-circle-2",
"icon-cancel-circle-2",
"icon-up-open",
"iconz-ok",
"iconz-message-full",
"appyicon-ar-1",
"appyicon-velocity",
"appyicon-nested-from",
"appyicon-geo-location",
"appyicon-reservio",
"appyicon-setmore",
"appyicon-mercadopago",
"appyicon-demand-delivery",
"appyicon-car-1",
"appyicon-car-2",
"appyicon-car-3",
"appyicon-tricycle-1",
"appyicon-tricycle-2",
"appyicon-tricycle-3",
"appyicon-vans-1",
"appyicon-vans-2",
"appyicon-vans-3",
"appyicon-truck-1",
"appyicon-truck-2",
"appyicon-motorcycle-2",
"appyicon-motorcycle-3",
"appyicon-authorize",
"icon1-A",
"icon1-B",
"icon1-C",
"icon1-D",
"icon1-P",
"snappy-icon-boleto",
"appyslim-love-anniversary",
"appyslim-love-balloons",
"appyslim-love-bible",
"appyslim-love-bottle-glass",
"appyslim-love-bow-tie",
"appyslim-love-bow-tie-2",
"appyslim-love-camera-filming",
"appyslim-love-candle-fire",
"appyslim-love-candles",
"appyslim-love-champagne",
"appyslim-love-church",
"appyslim-love-classic-piano",
"appyslim-love-coffee-meeting",
"appyslim-love-decoration",
"appyslim-love-diamond",
"appyslim-love-diamond-necklace",
"appyslim-love-do-not-disturb",
"appyslim-love-fell-in-love",
"appyslim-love-flowers",
"appyslim-love-groom-hat",
"appyslim-love-heart-lockpad",
"appyslim-love-heart-necklace",
"appyslim-love-heart-necklace-2",
"appyslim-love-heart-pulse",
"appyslim-love-heart-stick",
"appyslim-love-heart-sticks",
"appyslim-love-hearts",
"appyslim-love-love-bow",
"appyslim-love-love-chat",
"appyslim-love-love-keylock",
"appyslim-love-love-message",
"appyslim-love-love-rainbow",
"appyslim-love-lovely-bear",
"appyslim-love-lovely-bird",
"appyslim-love-male-female",
"appyslim-love-male-female-symbols",
"appyslim-love-marriage-proposal",
"appyslim-love-meeting-location",
"appyslim-love-outdoor-wedding",
"appyslim-love-perfume",
"appyslim-love-photos",
"appyslim-love-present-3",
"appyslim-love-read-love-message",
"appyslim-love-search-love",
"appyslim-love-special-dish",
"appyslim-love-tie",
"appyslim-love-valentine-cake",
"appyslim-love-valentine-mask",
"appyslim-love-wedding-cab",
"appyslim-love-wedding-cake",
"appyslim-love-wedding-dress",
"appyslim-love-wedding-invitation",
"appyslim-love-wedding-list",
"appyslim-love-wedding-music",
"appyslim-love-wedding-present",
"appyslim-love-wedding-ring",
"appyslim-love-wedding-rings",
"appyslim-love-wedding-shopping",
"appyslim-love-wedding-trip-bag",
"appyslim-love-wine-bottle",
"appyslim-weather-celsius",
"appyslim-weather-cloud",
"appyslim-weather-cloud-droplet",
"appyslim-weather-cloud-fog",
"appyslim-weather-cloud-rain",
"appyslim-weather-cloud-rain-1",
"appyslim-weather-cloud-rain-2",
"appyslim-weather-cloud-rain-snow",
"appyslim-weather-cloud-snowflafes",
"appyslim-weather-cloud-thunderbolt",
"appyslim-weather-clouds",
"appyslim-weather-cloudy-4",
"appyslim-weather-cloudy-4-rain",
"appyslim-weather-cloudy-fog",
"appyslim-weather-cloudy-night",
"appyslim-weather-cloudy-rain",
"appyslim-weather-cloudy-rain-2",
"appyslim-weather-cloudy-rain-3",
"appyslim-weather-cloudy-rain-4",
"appyslim-weather-cloudy-rain-thunderbolt",
"appyslim-weather-cloudy-shower",
"appyslim-weather-cloudy-snow",
"appyslim-weather-cloudy-thunderbolt",
"appyslim-weather-fahrenheit",
"appyslim-weather-fog",
"appyslim-weather-freeze",
"appyslim-weather-half-moon",
"appyslim-weather-half-sun",
"appyslim-weather-hot-temperature",
"appyslim-weather-humidity-percentage",
"appyslim-weather-hurricane",
"appyslim-weather-moon",
"appyslim-weather-moon-stars",
"appyslim-weather-night-fog",
"appyslim-weather-night-snow",
"appyslim-weather-rainbow",
"appyslim-weather-rainy-night",
"appyslim-weather-rainy-night-2",
"appyslim-weather-rainy-night-3",
"appyslim-weather-rainy-night-4",
"appyslim-weather-rainy-night-shower",
"appyslim-weather-rainy-night-thunderbolt",
"appyslim-weather-sea-waves",
"appyslim-weather-snowflake",
"appyslim-weather-sun",
"appyslim-weather-sun-cloud",
"appyslim-weather-sunrise",
"appyslim-weather-sunset",
"appyslim-weather-sunset-2",
"appyslim-weather-sunset-sea",
"appyslim-weather-temperature",
"appyslim-weather-temperature-decrease",
"appyslim-weather-temperature-drop",
"appyslim-weather-temperature-increase",
"appyslim-weather-thunderbolt-3",
"appyslim-weather-thunderbolt-night",
"appyslim-weather-tornado",
"appyslim-weather-umbrealla",
"appyslim-weather-umbrella-rain",
"appyslim-weather-water-droplets",
"appyslim-weather-weather-warning",
"appyslim-weather-wind-meter",
"appyslim-weather-winds",
"appyslim-weather-winds-rain",
"appyslim-ui-add",
"appyslim-ui-add-search",
"appyslim-ui-add-user",
"appyslim-ui-add-user-3",
"appyslim-ui-antena-signal",
"appyslim-ui-apps-home",
"appyslim-ui-automatic",
"appyslim-ui-barcode-scan",
"appyslim-ui-bell",
"appyslim-ui-bluetooth",
"appyslim-ui-bookmarks-2",
"appyslim-ui-bookmarks-list",
"appyslim-ui-chat-button",
"appyslim-ui-confirm",
"appyslim-ui-confirm-search",
"appyslim-ui-confirm-user",
"appyslim-ui-data-exchange",
"appyslim-ui-delete",
"appyslim-ui-delete-search",
"appyslim-ui-delete-user",
"appyslim-ui-delete-user-3",
"appyslim-ui-delete-x",
"appyslim-ui-download",
"appyslim-ui-edit",
"appyslim-ui-edit-profile",
"appyslim-ui-extract",
"appyslim-ui-flag",
"appyslim-ui-flag-3",
"appyslim-ui-forbidden",
"appyslim-ui-gauge",
"appyslim-ui-gps-lock",
"appyslim-ui-home-button",
"appyslim-ui-insert",
"appyslim-ui-interface-settings",
"appyslim-ui-lockpad",
"appyslim-ui-lockpad-4",
"appyslim-ui-lockpad-6",
"appyslim-ui-lockpad-lock",
"appyslim-ui-lockpad-target",
"appyslim-ui-login",
"appyslim-ui-logout",
"appyslim-ui-mail-message",
"appyslim-ui-minus",
"appyslim-ui-minus-2",
"appyslim-ui-minus-window",
"appyslim-ui-more-options",
"appyslim-ui-notice",
"appyslim-ui-on-off",
"appyslim-ui-on-off-2",
"appyslim-ui-open-door",
"appyslim-ui-open-door-inside",
"appyslim-ui-open-door-outside",
"appyslim-ui-options",
"appyslim-ui-plus",
"appyslim-ui-plus-window",
"appyslim-ui-profile-card",
"appyslim-ui-profile-user",
"appyslim-ui-qr-code",
"appyslim-ui-question",
"appyslim-ui-refresh",
"appyslim-ui-refresh-sync",
"appyslim-ui-remove-search",
"appyslim-ui-remove-user",
"appyslim-ui-search",
"appyslim-ui-search-2",
"appyslim-ui-search-2-add",
"appyslim-ui-search-2-delete",
"appyslim-ui-search-2-remove",
"appyslim-ui-settings",
"appyslim-ui-settings-2",
"appyslim-ui-settings-3",
"appyslim-ui-settings-gear",
"appyslim-ui-share",
"appyslim-ui-signal-search",
"appyslim-ui-speaker-mute",
"appyslim-ui-speaker-volume",
"appyslim-ui-star",
"appyslim-ui-torch",
"appyslim-ui-trash-bin",
"appyslim-ui-upload",
"appyslim-ui-user",
"appyslim-ui-user-3",
"appyslim-ui-user-list",
"appyslim-ui-users",
"appyslim-ui-window-button",
"appyslim-ui-window-button-add",
"appyslim-ui-window-button-remove",
"appyslim-ui-window-stack",
"appyslim-transport-air-balloon",
"appyslim-transport-air-balloon-2",
"appyslim-transport-airport",
"appyslim-transport-ambulance",
"appyslim-transport-battery",
"appyslim-transport-bicycle",
"appyslim-transport-bicycle-2",
"appyslim-transport-bus",
"appyslim-transport-bus-station",
"appyslim-transport-bus-stop",
"appyslim-transport-camp-car",
"appyslim-transport-car",
"appyslim-transport-car-wheel",
"appyslim-transport-cargo-plane",
"appyslim-transport-cargo-ship",
"appyslim-transport-city-train",
"appyslim-transport-container",
"appyslim-transport-cruise-ship",
"appyslim-transport-double-decker",
"appyslim-transport-electric-bus",
"appyslim-transport-fast-train",
"appyslim-transport-flying-balloon",
"appyslim-transport-forklift",
"appyslim-transport-fuel-station",
"appyslim-transport-gear-box",
"appyslim-transport-hand-trolley",
"appyslim-transport-helicopter",
"appyslim-transport-highway",
"appyslim-transport-liquid-truck",
"appyslim-transport-metro-sign",
"appyslim-transport-mini-bus",
"appyslim-transport-mountain-teleferik",
"appyslim-transport-oil-bottle",
"appyslim-transport-old-plane",
"appyslim-transport-pickup",
"appyslim-transport-plane",
"appyslim-transport-plane-face",
"appyslim-transport-plane-symbol",
"appyslim-transport-plane-symbol-2",
"appyslim-transport-road",
"appyslim-transport-road-sign",
"appyslim-transport-road-sign-2",
"appyslim-transport-road-stop",
"appyslim-transport-ship-anchor",
"appyslim-transport-ship-boat",
"appyslim-transport-ship-sea",
"appyslim-transport-small-bike",
"appyslim-transport-small-trolley",
"appyslim-transport-taxi",
"appyslim-transport-taxi-2",
"appyslim-transport-tractor",
"appyslim-transport-traffic-barricade",
"appyslim-transport-traffic-cone",
"appyslim-transport-traffic-light",
"appyslim-transport-traffic-triangle",
"appyslim-transport-train-car",
"appyslim-transport-train-tunnel",
"appyslim-transport-train-wagon",
"appyslim-transport-tram",
"appyslim-transport-transport-ship",
"appyslim-transport-trolley",
"appyslim-transport-trolley-box",
"appyslim-transport-truck",
"appyslim-transport-truck-2",
"appyslim-sports-aerobic",
"appyslim-sports-aerobic-trimmer",
"appyslim-sports-badminton",
"appyslim-sports-badminton-2",
"appyslim-sports-ball",
"appyslim-sports-baseball",
"appyslim-sports-baseball-arena",
"appyslim-sports-baseball-ball",
"appyslim-sports-baseball-stick",
"appyslim-sports-baseball-stick-ball",
"appyslim-sports-baseball-sticks",
"appyslim-sports-basketball",
"appyslim-sports-basketball-2",
"appyslim-sports-basketball-arena",
"appyslim-sports-basketball-table",
"appyslim-sports-basketball-table-2",
"appyslim-sports-basketball-table-4",
"appyslim-sports-basketball-throw",
"appyslim-sports-basketball-trophy",
"appyslim-sports-bicycle",
"appyslim-sports-billiard-8-ball",
"appyslim-sports-billiard-balls",
"appyslim-sports-billiard-table",
"appyslim-sports-billiard-trophy",
"appyslim-sports-boat",
"appyslim-sports-bowling",
"appyslim-sports-bowling-ball-pin",
"appyslim-sports-bowling-pin",
"appyslim-sports-bowling-pin-2",
"appyslim-sports-chess-pawn",
"appyslim-sports-chess-table",
"appyslim-sports-fc-flag",
"appyslim-sports-fencing",
"appyslim-sports-finish-flag",
"appyslim-sports-football-arena",
"appyslim-sports-football-ball",
"appyslim-sports-football-corner",
"appyslim-sports-football-goalpost",
"appyslim-sports-football-goalpost-2",
"appyslim-sports-football-trophy-2",
"appyslim-sports-game-cards",
"appyslim-sports-goal",
"appyslim-sports-golf-ball-3",
"appyslim-sports-golf-ball-4",
"appyslim-sports-golf-flag",
"appyslim-sports-hockey-ball",
"appyslim-sports-hockey-sticks",
"appyslim-sports-medal",
"appyslim-sports-medal-1-place",
"appyslim-sports-medal-2",
"appyslim-sports-medal-2-place",
"appyslim-sports-medal-3-place",
"appyslim-sports-ping-pong",
"appyslim-sports-podium",
"appyslim-sports-race-flag",
"appyslim-sports-roller-skates",
"appyslim-sports-rugby",
"appyslim-sports-rugby-ball",
"appyslim-sports-rugby-helmet",
"appyslim-sports-rugby-post",
"appyslim-sports-rugby-trophy",
"appyslim-sports-score-table",
"appyslim-sports-score-table-2",
"appyslim-sports-sport-flag",
"appyslim-sports-sport-shirt",
"appyslim-sports-stopwatch",
"appyslim-sports-stopwatch-chronometer",
"appyslim-sports-swimming-equipment",
"appyslim-sports-swimming-pool",
"appyslim-sports-sword",
"appyslim-sports-swords",
"appyslim-sports-tactics-strategy",
"appyslim-sports-target",
"appyslim-sports-tennis-ball",
"appyslim-sports-tennis-baseball",
"appyslim-sports-tennis-field",
"appyslim-sports-tennis-rocket",
"appyslim-sports-tennis-rockets",
"appyslim-sports-tennis-trophy",
"appyslim-sports-ticket",
"appyslim-sports-trophy",
"appyslim-sports-trophy-2",
"appyslim-sports-volley-net",
"appyslim-sports-volleyball",
"appyslim-sports-whistle",
"appyslim-sports-wight-lifting",
"appyslim-sports-wight-lifting-2",
"appyslim-sports-wight-lifting-3",
"appyslim-space-aquarius",
"appyslim-space-ares",
"appyslim-space-aries",
"appyslim-space-astronaut",
"appyslim-space-astronaut-2",
"appyslim-space-astronaut-3",
"appyslim-space-big-bang",
"appyslim-space-cancer",
"appyslim-space-capricorn",
"appyslim-space-capsule-flying",
"appyslim-space-galaxy",
"appyslim-space-gemini",
"appyslim-space-leo",
"appyslim-space-libra",
"appyslim-space-meteor-falling",
"appyslim-space-meteorite",
"appyslim-space-milky-way",
"appyslim-space-moon",
"appyslim-space-moon-landing",
"appyslim-space-observatory",
"appyslim-space-observatory-2",
"appyslim-space-pisces",
"appyslim-space-planet-ring",
"appyslim-space-planets-orbits",
"appyslim-space-sagittarius",
"appyslim-space-satellite",
"appyslim-space-scorpio",
"appyslim-space-small-spaceship",
"appyslim-space-space-capsule",
"appyslim-space-space-dish",
"appyslim-space-space-vehicle",
"appyslim-space-spaceship",
"appyslim-space-spaceship-takeoff",
"appyslim-space-taurus",
"appyslim-space-telescope",
"appyslim-space-ufo",
"appyslim-space-ufo-spacecraft",
"appyslim-space-ufo-spaceship-landing",
"appyslim-space-universe",
"appyslim-space-virgo",
"appyslim-spa-bamboo",
"appyslim-spa-bath-towel",
"appyslim-spa-body-oil",
"appyslim-spa-body-shaver",
"appyslim-spa-candle-fire",
"appyslim-spa-candle-jar",
"appyslim-spa-candles-2",
"appyslim-spa-clean-brush",
"appyslim-spa-cleansing-oil",
"appyslim-spa-comb",
"appyslim-spa-cream",
"appyslim-spa-eye-cream",
"appyslim-spa-eye-makeup",
"appyslim-spa-face-brush",
"appyslim-spa-face-brush-2",
"appyslim-spa-flip-flops",
"appyslim-spa-flower-4",
"appyslim-spa-hand-cream",
"appyslim-spa-hand-mirror",
"appyslim-spa-hand-mirror-2",
"appyslim-spa-hot-bath",
"appyslim-spa-lipstick",
"appyslim-spa-makeup-brush-set",
"appyslim-spa-makeup-set",
"appyslim-spa-massage-bed",
"appyslim-spa-massage-oil",
"appyslim-spa-massage-oil-2",
"appyslim-spa-mortar-pestle",
"appyslim-spa-nail-polish",
"appyslim-spa-night-cream",
"appyslim-spa-perfume",
"appyslim-spa-razor",
"appyslim-spa-razor-2",
"appyslim-spa-rose",
"appyslim-spa-scissors",
"appyslim-spa-shower",
"appyslim-spa-small-candles",
"appyslim-spa-spa-flower",
"appyslim-spa-spa-oil",
"appyslim-spa-spa-sign",
"appyslim-spa-stones",
"appyslim-spa-sunbed",
"appyslim-spa-sunflower",
"appyslim-spa-swim-pool",
"appyslim-spa-table-mirror",
"appyslim-spa-towel",
"appyslim-spa-water-droplet",
"appyslim-spa-yin-yang",
"appyslim-security-add-fingerprint",
"appyslim-security-add-lockpad",
"appyslim-security-add-shield",
"appyslim-security-bank-camera",
"appyslim-security-bank-pin",
"appyslim-security-bug-virus",
"appyslim-security-check-point",
"appyslim-security-confirm-check",
"appyslim-security-confirm-fingerprint",
"appyslim-security-confirm-location",
"appyslim-security-confirm-lockpad",
"appyslim-security-confirm-network",
"appyslim-security-confirm-shield",
"appyslim-security-delete-fingerprint",
"appyslim-security-delete-lockpad",
"appyslim-security-delete-network",
"appyslim-security-digital-numbers",
"appyslim-security-document-shredder",
"appyslim-security-door-alarm",
"appyslim-security-enter-pin",
"appyslim-security-eye-detection",
"appyslim-security-fence",
"appyslim-security-fingerprint",
"appyslim-security-firewall",
"appyslim-security-jail",
"appyslim-security-keylock",
"appyslim-security-keylock-2",
"appyslim-security-lockpad",
"appyslim-security-lockpad-2",
"appyslim-security-lockpad-3",
"appyslim-security-lockpad-hole",
"appyslim-security-no-fingerprint",
"appyslim-security-no-lockpad",
"appyslim-security-pin-input",
"appyslim-security-protected-computer",
"appyslim-security-protected-laptop",
"appyslim-security-remove-lockpad",
"appyslim-security-remove-shield",
"appyslim-security-safe-shield",
"appyslim-security-safety-wall",
"appyslim-security-security-camera",
"appyslim-security-sheriff-medal",
"appyslim-security-shield-cross",
"appyslim-security-shield-star",
"appyslim-security-shield-stripes",
"appyslim-security-siren-alarm",
"appyslim-security-sniper-targer",
"appyslim-security-thief",
"appyslim-education-3d-cube",
"appyslim-education-abc-board",
"appyslim-education-abc-cubes",
"appyslim-education-academic-cap",
"appyslim-education-academic-cap-2",
"appyslim-education-arithmetics",
"appyslim-education-atom",
"appyslim-education-bell",
"appyslim-education-big-bang",
"appyslim-education-big-bang-2",
"appyslim-education-bio-hazard",
"appyslim-education-biohazard",
"appyslim-education-book",
"appyslim-education-book-2",
"appyslim-education-book-3",
"appyslim-education-book-apple",
"appyslim-education-books",
"appyslim-education-calculator",
"appyslim-education-calculator-2",
"appyslim-education-chemistry-bottles",
"appyslim-education-chemistry-elements",
"appyslim-education-chemistry-experiment",
"appyslim-education-chemistry-glass",
"appyslim-education-circuit",
"appyslim-education-compass",
"appyslim-education-divide",
"appyslim-education-dna",
"appyslim-education-dna-2",
"appyslim-education-earth-stand",
"appyslim-education-earth-symbol",
"appyslim-education-empty-set",
"appyslim-education-equals",
"appyslim-education-eraser",
"appyslim-education-experiment",
"appyslim-education-fibonacci-sequence",
"appyslim-education-greater-than",
"appyslim-education-human-skull",
"appyslim-education-identical",
"appyslim-education-infinity",
"appyslim-education-less-than",
"appyslim-education-magnet",
"appyslim-education-marker",
"appyslim-education-matter",
"appyslim-education-matter-connection",
"appyslim-education-minus",
"appyslim-education-mouse-experiment",
"appyslim-education-multiply",
"appyslim-education-neutron",
"appyslim-education-not-equal",
"appyslim-education-not-equal-2",
"appyslim-education-note-sticker",
"appyslim-education-notebook",
"appyslim-education-notebook-2",
"appyslim-education-nuclear-bomb",
"appyslim-education-observatory",
"appyslim-education-oval-ruler",
"appyslim-education-p-letter",
"appyslim-education-panet-stars-3",
"appyslim-education-pen-edge",
"appyslim-education-pen-stylus",
"appyslim-education-pencil",
"appyslim-education-pencil-eraser",
"appyslim-education-physic-elements",
"appyslim-education-physics-gravity",
"appyslim-education-planet-orbit",
"appyslim-education-planet-orbit-2",
"appyslim-education-plantes-orbit",
"appyslim-education-plus",
"appyslim-education-plus-minus",
"appyslim-education-presentation-board",
"appyslim-education-professor-bag",
"appyslim-education-protons-neutrons",
"appyslim-education-radical-equation",
"appyslim-education-ruler",
"appyslim-education-school",
"appyslim-education-school-degree",
"appyslim-education-science-book",
"appyslim-education-science-degree",
"appyslim-education-science-document",
"appyslim-education-science-glasses",
"appyslim-education-science-microscope",
"appyslim-education-search-research",
"appyslim-education-square-root",
"appyslim-education-square-root-2",
"appyslim-education-students-class",
"appyslim-education-sum",
"appyslim-education-sun-beams",
"appyslim-education-telescope",
"appyslim-education-tie",
"appyslim-education-transformer",
"appyslim-education-triangle-ruler",
"appyslim-education-university",
"appyslim-education-virus-elements",
"appyslim-education-virus-microscope-2",
"appyslim-education-virus-research",
"appyslim-education-x-y-location",
"appyslim-photo-4-3-ratio",
"appyslim-photo-15s-selftimer",
"appyslim-photo-16-9-ratio",
"appyslim-photo-30s-selftimer",
"appyslim-photo-45s-selftimer",
"appyslim-photo-60-selftimer",
"appyslim-photo-360-panorama",
"appyslim-photo-add-image",
"appyslim-photo-aperture",
"appyslim-photo-auto-flash",
"appyslim-photo-auto-flash-symbol",
"appyslim-photo-back-camera",
"appyslim-photo-barrel-distortion",
"appyslim-photo-battery-flash",
"appyslim-photo-bulb-white-balance",
"appyslim-photo-camera",
"appyslim-photo-camera-chip",
"appyslim-photo-camera-remote",
"appyslim-photo-center-weighted-metering",
"appyslim-photo-cloudy-white-balance",
"appyslim-photo-confirm-image",
"appyslim-photo-contrast",
"appyslim-photo-curves",
"appyslim-photo-decrease-flash",
"appyslim-photo-delete-image",
"appyslim-photo-diffuser-umbrella",
"appyslim-photo-dslr",
"appyslim-photo-dslr-lens",
"appyslim-photo-ev-exposure",
"appyslim-photo-face-detection",
"appyslim-photo-favorite-image",
"appyslim-photo-favorite-image-2",
"appyslim-photo-film",
"appyslim-photo-fish-eye",
"appyslim-photo-flash-fire",
"appyslim-photo-flash-on",
"appyslim-photo-flash-symbol",
"appyslim-photo-focus-infinity",
"appyslim-photo-focus-point",
"appyslim-photo-focus-point-4",
"appyslim-photo-focus-points",
"appyslim-photo-horizon-level",
"appyslim-photo-image-crop",
"appyslim-photo-image-element",
"appyslim-photo-image-files",
"appyslim-photo-image-review",
"appyslim-photo-increase-flash",
"appyslim-photo-iso",
"appyslim-photo-landscape-picture",
"appyslim-photo-large-aperture",
"appyslim-photo-magic-tools",
"appyslim-photo-matrix-metering",
"appyslim-photo-micro-sd",
"appyslim-photo-multi-exposure",
"appyslim-photo-no-flash",
"appyslim-photo-no-flash-2",
"appyslim-photo-no-flash-symbol",
"appyslim-photo-octagon-softbox",
"appyslim-photo-on-flash",
"appyslim-photo-panorama",
"appyslim-photo-photo",
"appyslim-photo-pincushion-distortion",
"appyslim-photo-red-eye",
"appyslim-photo-remove-image",
"appyslim-photo-rgb-colors",
"appyslim-photo-rotate-camera",
"appyslim-photo-rule-thirds",
"appyslim-photo-screen-focusing",
"appyslim-photo-sd-card",
"appyslim-photo-shade-white-balance",
"appyslim-photo-softbox",
"appyslim-photo-spot-metering",
"appyslim-photo-straighten",
"appyslim-photo-studio-light",
"appyslim-photo-sunlight-white-balance",
"appyslim-photo-timer",
"appyslim-photo-tripod",
"appyslim-photo-white-balance",
"appyslim-photo-zoom-in",
"appyslim-photo-zoom-out",
"appyslim-phone-2g-connection",
"appyslim-phone-3g-connection-data",
"appyslim-phone-3g-symbol",
"appyslim-phone-4g-connection",
"appyslim-phone-4g-network",
"appyslim-phone-5g-connection",
"appyslim-phone-5g-symbol",
"appyslim-phone-24-call-support",
"appyslim-phone-add-call",
"appyslim-phone-alarm",
"appyslim-phone-app-store",
"appyslim-phone-app-store-icon",
"appyslim-phone-bluetooth",
"appyslim-phone-bluetooth-signal",
"appyslim-phone-call-logs",
"appyslim-phone-call-message",
"appyslim-phone-call-recording",
"appyslim-phone-call-signal",
"appyslim-phone-call-signal-2",
"appyslim-phone-call-talk",
"appyslim-phone-cdma-signal",
"appyslim-phone-contacts",
"appyslim-phone-data-connection",
"appyslim-phone-dialpad",
"appyslim-phone-drop-call",
"appyslim-phone-edge-signal",
"appyslim-phone-gprs-signal",
"appyslim-phone-gsm-signal",
"appyslim-phone-home-button",
"appyslim-phone-hsdpa-signal",
"appyslim-phone-hsdpa-signal-2",
"appyslim-phone-incoming-call",
"appyslim-phone-iphone",
"appyslim-phone-lte-signal",
"appyslim-phone-message-notification",
"appyslim-phone-micro-sim",
"appyslim-phone-missed-call",
"appyslim-phone-missed-call-2",
"appyslim-phone-mute-bell",
"appyslim-phone-mute-call",
"appyslim-phone-nfc-connection",
"appyslim-phone-no-phone-wifi",
"appyslim-phone-no-sim-card",
"appyslim-phone-notifications",
"appyslim-phone-outgoing-call",
"appyslim-phone-phone-add",
"appyslim-phone-phone-battery",
"appyslim-phone-phone-battery-full",
"appyslim-phone-phone-bell",
"appyslim-phone-phone-calendar",
"appyslim-phone-phone-call",
"appyslim-phone-phone-camera",
"appyslim-phone-phone-charging",
"appyslim-phone-phone-charging-2",
"appyslim-phone-phone-chat",
"appyslim-phone-phone-cloud",
"appyslim-phone-phone-confirm",
"appyslim-phone-phone-connected",
"appyslim-phone-phone-connection",
"appyslim-phone-phone-disconnected",
"appyslim-phone-phone-favorites",
"appyslim-phone-phone-favorites-2",
"appyslim-phone-phone-gps",
"appyslim-phone-phone-incoming",
"appyslim-phone-phone-location",
"appyslim-phone-phone-lock",
"appyslim-phone-phone-mail",
"appyslim-phone-phone-media",
"appyslim-phone-phone-mic",
"appyslim-phone-phone-network",
"appyslim-phone-phone-outgoing",
"appyslim-phone-phone-payment",
"appyslim-phone-phone-pictures",
"appyslim-phone-phone-remove",
"appyslim-phone-phone-ringing",
"appyslim-phone-phone-ringing-2",
"appyslim-phone-phone-search",
"appyslim-phone-phone-security",
"appyslim-phone-phone-settings",
"appyslim-phone-phone-share",
"appyslim-phone-phone-shopping",
"appyslim-phone-phone-signal",
"appyslim-phone-phone-sms",
"appyslim-phone-phone-symbol",
"appyslim-phone-phone-time",
"appyslim-phone-phone-user",
"appyslim-phone-phone-vibration",
"appyslim-phone-phone-wifi",
"appyslim-phone-phone-wifi-2",
"appyslim-phone-remove-call",
"appyslim-phone-ring-bell",
"appyslim-phone-sim-card",
"appyslim-phone-sleep-mode",
"appyslim-phone-smartphone",
"appyslim-phone-swipe-notifications",
"appyslim-phone-vibration",
"appyslim-party-active-firework",
"appyslim-party-active-firework-2",
"appyslim-party-balloon",
"appyslim-party-balloons",
"appyslim-party-candies",
"appyslim-party-christmas-ball",
"appyslim-party-christmas-cake",
"appyslim-party-christmas-cake-2",
"appyslim-party-christmas-calendar",
"appyslim-party-christmas-candle",
"appyslim-party-christmas-candle-2",
"appyslim-party-christmas-candy",
"appyslim-party-christmas-cap-3",
"appyslim-party-christmas-cute-cap",
"appyslim-party-christmas-day",
"appyslim-party-christmas-glove",
"appyslim-party-christmas-glove-2",
"appyslim-party-christmas-mask",
"appyslim-party-christmas-ornaments",
"appyslim-party-christmas-shopping",
"appyslim-party-christmas-snowball",
"appyslim-party-christmas-socks",
"appyslim-party-christmas-star",
"appyslim-party-christmas-star-2",
"appyslim-party-christmas-tree",
"appyslim-party-cookie-man",
"appyslim-party-door-bell",
"appyslim-party-door-star",
"appyslim-party-falling-star",
"appyslim-party-fireplace",
"appyslim-party-firework-4",
"appyslim-party-firework-stars",
"appyslim-party-fireworks",
"appyslim-party-holding-candle",
"appyslim-party-holding-star",
"appyslim-party-holy-cross",
"appyslim-party-hot-serving-plate",
"appyslim-party-moon-stars",
"appyslim-party-present-2",
"appyslim-party-present-gift",
"appyslim-party-santa-claus-hat",
"appyslim-party-shopping-discount",
"appyslim-party-ski-boots",
"appyslim-party-snowflake",
"appyslim-party-snowman",
"appyslim-party-star-stand",
"appyslim-party-wax-candle",
"appyslim-party-winter-cap",
"appyslim-network-add-network-drive",
"appyslim-network-antena-signal-3",
"appyslim-network-cloud-add",
"appyslim-network-cloud-confirm",
"appyslim-network-cloud-connection",
"appyslim-network-cloud-connection-2",
"appyslim-network-cloud-connection-4",
"appyslim-network-cloud-delete",
"appyslim-network-cloud-download",
"appyslim-network-cloud-favorites",
"appyslim-network-cloud-file-search",
"appyslim-network-cloud-links",
"appyslim-network-cloud-peers",
"appyslim-network-cloud-refresh",
"appyslim-network-cloud-remove",
"appyslim-network-cloud-secure",
"appyslim-network-cloud-signal",
"appyslim-network-cloud-upload",
"appyslim-network-communication-hub",
"appyslim-network-computer-connection",
"appyslim-network-connected-computers",
"appyslim-network-connected-servers",
"appyslim-network-connected-servers-2",
"appyslim-network-connection-cable",
"appyslim-network-connection-route",
"appyslim-network-connection-tree",
"appyslim-network-database",
"appyslim-network-database-add",
"appyslim-network-database-delete",
"appyslim-network-database-links",
"appyslim-network-database-refresh",
"appyslim-network-database-remove",
"appyslim-network-database-signal",
"appyslim-network-delete-network-drive",
"appyslim-network-desktop-connection",
"appyslim-network-ethernet-port",
"appyslim-network-global-network",
"appyslim-network-home-connection",
"appyslim-network-home-wireless-connection",
"appyslim-network-hub",
"appyslim-network-link-network-drive",
"appyslim-network-main-antena",
"appyslim-network-network-confirm",
"appyslim-network-network-drive",
"appyslim-network-network-folders",
"appyslim-network-network-links",
"appyslim-network-network-refresh",
"appyslim-network-network-signal",
"appyslim-network-network-signal-4",
"appyslim-network-network-speed",
"appyslim-network-no-network",
"appyslim-network-phone-antena",
"appyslim-network-refresh-network-drive",
"appyslim-network-remove-network-drive",
"appyslim-network-router",
"appyslim-network-search-signal",
"appyslim-network-signal-antena",
"appyslim-network-signal-waves",
"appyslim-network-wifi-connected",
"appyslim-network-wifi-disconnected",
"appyslim-network-wifi-network-drive",
"appyslim-network-wifi-signal",
"appyslim-network-wifi-signal-2",
"appyslim-network-wifi-transfer",
"appyslim-music-3",
"appyslim-music-add-button",
"appyslim-music-add-headphones",
"appyslim-music-add-mic",
"appyslim-music-audio-analysis",
"appyslim-music-audio-chart",
"appyslim-music-audio-chart-2",
"appyslim-music-audio-disc",
"appyslim-music-audio-file",
"appyslim-music-audio-jack",
"appyslim-music-audio-knob",
"appyslim-music-audio-settings",
"appyslim-music-audio-settings-3",
"appyslim-music-back-button",
"appyslim-music-banjo",
"appyslim-music-car-speaker",
"appyslim-music-cloud-music",
"appyslim-music-confirm-headphones",
"appyslim-music-confirm-mic",
"appyslim-music-decrease-volume",
"appyslim-music-disc-headphones",
"appyslim-music-disconnect-headphones",
"appyslim-music-disconnect-mic",
"appyslim-music-drum",
"appyslim-music-eject-button",
"appyslim-music-eject-button-2",
"appyslim-music-flute",
"appyslim-music-forward-button",
"appyslim-music-forward-button-2",
"appyslim-music-full-volume",
"appyslim-music-guitar",
"appyslim-music-headphones",
"appyslim-music-headphones-2",
"appyslim-music-increase-volume",
"appyslim-music-less-volume",
"appyslim-music-list-button",
"appyslim-music-mic-4",
"appyslim-music-microphone",
"appyslim-music-microphone-2",
"appyslim-music-microphone-3",
"appyslim-music-mid-volume",
"appyslim-music-mpr-player-2",
"appyslim-music-music-folder",
"appyslim-music-mute-speaker",
"appyslim-music-mute-volume",
"appyslim-music-no-audio",
"appyslim-music-nore-5",
"appyslim-music-note",
"appyslim-music-note-2",
"appyslim-music-note-3",
"appyslim-music-old-cassete",
"appyslim-music-old-music-player",
"appyslim-music-paly-pause-button",
"appyslim-music-pause-button",
"appyslim-music-pause-button-2",
"appyslim-music-piano",
"appyslim-music-play-button",
"appyslim-music-play-button-3",
"appyslim-music-player-settings",
"appyslim-music-playlist",
"appyslim-music-quit-button",
"appyslim-music-record-button",
"appyslim-music-record-button-2",
"appyslim-music-remove-button",
"appyslim-music-remove-headphones",
"appyslim-music-remove-mic",
"appyslim-music-repeat-button",
"appyslim-music-rewind-button",
"appyslim-music-rewind-button-2",
"appyslim-music-rewind-pause-button",
"appyslim-music-shuffle",
"appyslim-music-shuffle-2",
"appyslim-music-singer-microphone",
"appyslim-music-song-favorites",
"appyslim-music-sound-settings",
"appyslim-music-speaker",
"appyslim-music-speaker-2",
"appyslim-music-speaker-loud",
"appyslim-music-stop-button",
"appyslim-music-stop-button-2",
"appyslim-medical-ambulance",
"appyslim-medical-ambulance-siren",
"appyslim-medical-bed",
"appyslim-medical-belly",
"appyslim-medical-blood-droplet",
"appyslim-medical-confirmed-patient-history",
"appyslim-medical-damaged-teeth",
"appyslim-medical-disabled-wheelchair",
"appyslim-medical-dna",
"appyslim-medical-doctor-agenta",
"appyslim-medical-drug-chemistry",
"appyslim-medical-drug-glass",
"appyslim-medical-drugs-bottle",
"appyslim-medical-emergency-call",
"appyslim-medical-emergency-symbol",
"appyslim-medical-emergency-symbol-2",
"appyslim-medical-enema",
"appyslim-medical-eye",
"appyslim-medical-female-sign",
"appyslim-medical-first-aid-box",
"appyslim-medical-gauze",
"appyslim-medical-health-agenta-2",
"appyslim-medical-health-card",
"appyslim-medical-health-document",
"appyslim-medical-health-flag",
"appyslim-medical-health-information",
"appyslim-medical-health-organization",
"appyslim-medical-health-rate",
"appyslim-medical-health-records",
"appyslim-medical-health-staff",
"appyslim-medical-health-symbol",
"appyslim-medical-health-symbol-2",
"appyslim-medical-health-symbol-3",
"appyslim-medical-health-table",
"appyslim-medical-heart",
"appyslim-medical-heart-monitor",
"appyslim-medical-hospital",
"appyslim-medical-hospital-bed",
"appyslim-medical-hospital-helicopter-sign",
"appyslim-medical-hospital-location",
"appyslim-medical-hospital-soup",
"appyslim-medical-injection",
"appyslim-medical-laborator-glasses",
"appyslim-medical-laborator-sample",
"appyslim-medical-lungs",
"appyslim-medical-male-sign",
"appyslim-medical-microscope",
"appyslim-medical-no-patient-history",
"appyslim-medical-nurse-hat",
"appyslim-medical-oval-pill",
"appyslim-medical-ovum-sperm",
"appyslim-medical-patient-history",
"appyslim-medical-patient-moving-bed",
"appyslim-medical-pill-bottle",
"appyslim-medical-pills",
"appyslim-medical-pills-2",
"appyslim-medical-pulse",
"appyslim-medical-scissors",
"appyslim-medical-search-virus",
"appyslim-medical-sperm",
"appyslim-medical-stethoscope",
"appyslim-medical-teeth",
"appyslim-medical-virus",
"appyslim-medical-wounded-foot",
"appyslim-repair-abs",
"appyslim-repair-brakes",
"appyslim-repair-car-engine",
"appyslim-repair-car-horn",
"appyslim-repair-car-shocks",
"appyslim-repair-car-shocks-2",
"appyslim-repair-car-wrench",
"appyslim-repair-engine-belt",
"appyslim-repair-engine-chip",
"appyslim-repair-engine-failure",
"appyslim-repair-engine-oil",
"appyslim-repair-engine-piston",
"appyslim-repair-eps",
"appyslim-repair-gauge",
"appyslim-repair-gear",
"appyslim-repair-gear-1",
"appyslim-repair-gear-2",
"appyslim-repair-gear-3",
"appyslim-repair-gear-box",
"appyslim-repair-gear-box-symbol",
"appyslim-repair-gears",
"appyslim-repair-handbrake-symbol",
"appyslim-repair-lights-on",
"appyslim-repair-lights-on-down",
"appyslim-repair-lights-on-up",
"appyslim-repair-liquid-temperature",
"appyslim-repair-mechanic",
"appyslim-repair-mechanic-hat",
"appyslim-repair-no-lights",
"appyslim-repair-oil-sink",
"appyslim-repair-parking-symbol",
"appyslim-repair-safety-triangle",
"appyslim-repair-steel-nut",
"appyslim-repair-steering-wheel",
"appyslim-repair-turbo",
"appyslim-repair-wheel",
"appyslim-repair-wheel-base",
"appyslim-repair-windscreen",
"appyslim-repair-windscreen-air",
"appyslim-repair-windscreen-water",
"appyslim-seo-add-hyperlink",
"appyslim-seo-add-link",
"appyslim-seo-bookmarks",
"appyslim-seo-campaign-stats",
"appyslim-seo-cloud-computing",
"appyslim-seo-cloud-seo",
"appyslim-seo-conversion",
"appyslim-seo-delete-hyperlink",
"appyslim-seo-email-marketing",
"appyslim-seo-hyperlink",
"appyslim-seo-keyword-search",
"appyslim-seo-keyword-stats",
"appyslim-seo-link-chain",
"appyslim-seo-link-chain-2",
"appyslim-seo-link-chain-delete",
"appyslim-seo-link-chain-remove",
"appyslim-seo-link-share",
"appyslim-seo-market-growth",
"appyslim-seo-market-share",
"appyslim-seo-marketing-idea",
"appyslim-seo-marketing-idea-2",
"appyslim-seo-no-ads",
"appyslim-seo-optimization-growth-stats",
"appyslim-seo-page-search-optimization",
"appyslim-seo-remove-hyperlink",
"appyslim-seo-search-box",
"appyslim-seo-search-glass",
"appyslim-seo-search-rank",
"appyslim-seo-search-stats",
"appyslim-seo-seo-flag",
"appyslim-seo-seo-list",
"appyslim-seo-seo-promotion",
"appyslim-seo-seo-tags",
"appyslim-seo-seo-target",
"appyslim-seo-seo-target-2",
"appyslim-seo-seo-techniques",
"appyslim-seo-site-spy",
"appyslim-seo-stats-chart-pie",
"appyslim-seo-target",
"appyslim-seo-target-audience",
"appyslim-seo-target-audience-2",
"appyslim-seo-target-search-engine",
"appyslim-seo-video-marketing",
"appyslim-seo-web-analytics",
"appyslim-seo-web-page-settings",
"appyslim-seo-web-search",
"appyslim-seo-website-code",
"appyslim-seo-website-target",
"appyslim-mail-add-attachment",
"appyslim-mail-add-mail",
"appyslim-mail-add-mail-4",
"appyslim-mail-add-mail-5",
"appyslim-mail-at-sign",
"appyslim-mail-at-sign-2",
"appyslim-mail-attach",
"appyslim-mail-attachment-3",
"appyslim-mail-cloud-mail",
"appyslim-mail-confirm-mail",
"appyslim-mail-delete-mail",
"appyslim-mail-delete-mail-2",
"appyslim-mail-download-mail",
"appyslim-mail-email-attachment",
"appyslim-mail-email-sent",
"appyslim-mail-favorite-mail",
"appyslim-mail-file-attachment",
"appyslim-mail-letter-mail-6",
"appyslim-mail-lock-mail",
"appyslim-mail-mail",
"appyslim-mail-mail-2",
"appyslim-mail-mail-address",
"appyslim-mail-mail-attachment",
"appyslim-mail-mail-cut",
"appyslim-mail-mail-favorites",
"appyslim-mail-mail-letter",
"appyslim-mail-mail-letter-2",
"appyslim-mail-mail-letter-5",
"appyslim-mail-mail-link",
"appyslim-mail-mail-move",
"appyslim-mail-post-box",
"appyslim-mail-read-mail",
"appyslim-mail-receive-mail",
"appyslim-mail-remove-attachment",
"appyslim-mail-remove-mail",
"appyslim-mail-remove-mail-3",
"appyslim-mail-search-mail",
"appyslim-mail-secure-mail-3",
"appyslim-mail-send-arrow",
"appyslim-mail-send-mail",
"appyslim-mail-send-mail-6",
"appyslim-mail-share-mail",
"appyslim-mail-sound-mail",
"appyslim-mail-spam-mail",
"appyslim-mail-trash-mail",
"appyslim-mail-upload-mail",
"appyslim-mail-urgent-mail",
"appyslim-mail-user-mail",
"appyslim-logistics-24h-shipping",
"appyslim-logistics-add-box",
"appyslim-logistics-big-box-handles",
"appyslim-logistics-box",
"appyslim-logistics-box-2",
"appyslim-logistics-box-details",
"appyslim-logistics-box-direction",
"appyslim-logistics-box-fragile",
"appyslim-logistics-box-handles",
"appyslim-logistics-box-hands",
"appyslim-logistics-box-load",
"appyslim-logistics-box-loading",
"appyslim-logistics-box-loading-2",
"appyslim-logistics-box-location",
"appyslim-logistics-box-unload",
"appyslim-logistics-ce-certificate",
"appyslim-logistics-confirm-box",
"appyslim-logistics-confirm-receipt",
"appyslim-logistics-fragile-items",
"appyslim-logistics-insert-box",
"appyslim-logistics-insert-box-2",
"appyslim-logistics-item-weight",
"appyslim-logistics-locked-box",
"appyslim-logistics-no-box",
"appyslim-logistics-non-waterproof",
"appyslim-logistics-offer-box",
"appyslim-logistics-open-box-2",
"appyslim-logistics-open-small-box",
"appyslim-logistics-remove-box",
"appyslim-logistics-search-box",
"appyslim-logistics-send-box",
"appyslim-logistics-shipping",
"appyslim-logistics-small-box",
"appyslim-logistics-warehouse",
"appyslim-logistics-weight-kg",
"appyslim-logistics-wooden-box",
"appyslim-logistics-wooden-box-2",
"appyslim-logistics-wooden-box-3",
"appyslim-logistics-wooden-box-4",
"appyslim-logistics-wrapped-box",
"appyslim-laundry-30c",
"appyslim-laundry-40c",
"appyslim-laundry-50c",
"appyslim-laundry-any-solvent",
"appyslim-laundry-any-solvent-except-tetrachlorethylene",
"appyslim-laundry-any-solvent-except-tetrachlorethylene-2",
"appyslim-laundry-any-solvent-except-tetrachlorethylene-3",
"appyslim-laundry-bleach-if-needed",
"appyslim-laundry-clean-clothes",
"appyslim-laundry-cloth-basket",
"appyslim-laundry-cloth-hanger",
"appyslim-laundry-clothes-drying",
"appyslim-laundry-detergent",
"appyslim-laundry-detergent-2",
"appyslim-laundry-detergent-spoon",
"appyslim-laundry-dirty-clothes",
"appyslim-laundry-do-not-bleach",
"appyslim-laundry-do-not-dryclean",
"appyslim-laundry-do-not-tumble-dry",
"appyslim-laundry-do-not-wash",
"appyslim-laundry-do-not-wring",
"appyslim-laundry-drip-dry",
"appyslim-laundry-dry",
"appyslim-laundry-dry-flat-2",
"appyslim-laundry-dry-in-the-shade",
"appyslim-laundry-dry-normal-high-heat",
"appyslim-laundry-dry-normal-low-heat",
"appyslim-laundry-dry-normal-medium-heat",
"appyslim-laundry-dryclean",
"appyslim-laundry-extra-large",
"appyslim-laundry-extra-small",
"appyslim-laundry-faucet",
"appyslim-laundry-gentle-delicate",
"appyslim-laundry-hand-cream",
"appyslim-laundry-hand-wash",
"appyslim-laundry-hand-washing",
"appyslim-laundry-hang-to-dry",
"appyslim-laundry-hanger",
"appyslim-laundry-iron",
"appyslim-laundry-iron-max-no-steam",
"appyslim-laundry-iron-max-steam",
"appyslim-laundry-iron-max-temp-110",
"appyslim-laundry-iron-max-temp-150",
"appyslim-laundry-iron-max-temp-200",
"appyslim-laundry-iron-steam-stand",
"appyslim-laundry-large",
"appyslim-laundry-low-heat",
"appyslim-laundry-machine-wash",
"appyslim-laundry-machine-wash-gentle-delicate",
"appyslim-laundry-machine-wash-permanent-press",
"appyslim-laundry-medium",
"appyslim-laundry-no-detergent",
"appyslim-laundry-no-dry",
"appyslim-laundry-no-iron",
"appyslim-laundry-no-steam-finishing",
"appyslim-laundry-non-chlorine",
"appyslim-laundry-non-chlorine-2",
"appyslim-laundry-permanent-press",
"appyslim-laundry-petroleum-solvent-only",
"appyslim-laundry-petroleum-solvent-only-2",
"appyslim-laundry-reduced-moisture",
"appyslim-laundry-short-cycle",
"appyslim-laundry-shower",
"appyslim-laundry-small",
"appyslim-laundry-sponge",
"appyslim-laundry-tumble-dry",
"appyslim-laundry-wash-30c",
"appyslim-laundry-wash-40c",
"appyslim-laundry-wash-50c",
"appyslim-laundry-wash-60c",
"appyslim-laundry-wash-70c",
"appyslim-laundry-wash-80c",
"appyslim-laundry-wash-90c",
"appyslim-laundry-washing-machine",
"appyslim-laundry-washing-machine-2",
"appyslim-laundry-wet-cleaning",
"appyslim-laundry-wet-cleaning-2",
"appyslim-laundry-wet-cleaning-3",
"appyslim-laundry-wring",
"appyslim-laundry-xx-large",
"appyslim-industry-box-transfer",
"appyslim-industry-bread",
"appyslim-industry-brush-cutter",
"appyslim-industry-diode-led"

]

    
export default data;